import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function ProtectedRoute() {
  const token = localStorage.getItem('token');

  // If token exists → allow route, else redirect
  return token ? <Outlet /> : <Navigate to="/master-login" />;
}

export default ProtectedRoute;
